$( function() {
  // common










  $( '.bold_option_title' ).on( 'click', function() {
    $( this ).toggleClass( 'add-active' );
    $( this ).next().slideToggle();
  });




    






  (function(){
    if (window.matchMedia('(max-width: 767px)').matches){

     $('.boost-pfs-filter-display-list').trigger('click');
    };

    }());

  





});
jQuery(document).ready(function(){

 
  $( span ).on( 'click', function() {
    $( this ).toggleClass( 'add-active' );
    $( this ).next().slideToggle();
  });

  

  

  
 });